angular.module('cfn').directive('cfnBookingNotes', [
  'bookingRules',
  function(bookingRules) {
    'use strict';

    return {
      restrict: 'E',
      templateUrl: require('./notesTable.html'),

      controller: [
        '$scope',
        function($scope) {
          // DataModel -> ViewModel
          bookingRules.elements.notes.onLoad = function(result) {
            if (result.extraData) {
              $scope.notes = result.extraData.notes || '';
            } else {
              $scope.notes = null;
            }
          };

          // ViewModel -> DataModel
          bookingRules.elements.notes.onSave = function(result) {
            result.extraData = result.extraData || {};
            result.extraData.notes = $scope.notes;
          };
        }
      ]
    };
  }
]);
